import { hasFeatureFlag } from '@janeapp/feature-flags-client';
import { redirect } from '@tanstack/react-router';
import { getAuthenticated, isAuthExpired } from '~/utilities';

export function protectRoute() {
  const authenticationEnabled = hasFeatureFlag('AUTHENTICATION_ENABLED');

  if (!authenticationEnabled) return;

  const isAuthenticated = getAuthenticated() && !isAuthExpired();

  if (!isAuthenticated) {
    throw redirect({
      to: '/login',
      search: {
        redirect: location.href,
      },
    });
  }
}
